import React, {useEffect, useState} from 'react';
import * as actions from './AppTemplateActions';
import AccessUnauthorizedPage from './AccessUnauthorizedPage';
import {useDispatch} from 'react-redux';
import NotFoundPage from './NotFoundPage';
import {useHistory, useLocation} from 'react-router-dom';

const App = ({children}) => {
    const [status, setStatus] = useState(null);
    const location = useLocation();
    const history = useHistory();
    const dispatch = useDispatch();

    useEffect(() => {
        actions.getEmbeddedPageStatus(({status}) => {
            setStatus(status);
            if (status === 'Active') {
                dispatch(actions.reloadProfile());
            }
        });

        if (location.pathname.includes('embedded')) {
            const searchParams = location.search.replace(/slab|lumber|bundle|industrial_pack/gi, 'item');
            const newPath = location.pathname.replace('embedded_', '').replace('boards_and_beams', 'lumbers') + searchParams;
            history.push(newPath);
        }
    }, []);


    return status && (
        <React.Fragment>
            {status === 'Active' && <div>
                {children}
            </div>}
            {status === 'Inactive' && <AccessUnauthorizedPage />}
            {status === 'Not found' && <NotFoundPage />}
        </React.Fragment>
    );
};

export default App;


// WEBPACK FOOTER //
// ./src/containers/template/App.js